import React from 'react';

// 16-LED progressive RPM shift-light strip (MoTeC / Bosch DDU style).
// Color bands: LEDs 1-8 green, 9-13 amber, 14-16 blue.
// Blue LEDs switch to flashing red when shiftFlash is true (near redline).
const LED_COLORS = [
  '#10b981', '#10b981', '#10b981', '#10b981', '#10b981', '#10b981', '#10b981', '#10b981',
  '#f59e0b', '#f59e0b', '#f59e0b', '#f59e0b', '#f59e0b',
  '#3b82f6', '#3b82f6', '#3b82f6',
];

export default function ShiftLights({ rpmPct, shiftFlash = false }) {
  const pct = rpmPct != null ? Math.max(0, Math.min(100, rpmPct)) : 0;

  return (
    <div className="flex gap-1 w-full">
      {LED_COLORS.map((color, i) => {
        const threshold = (i / 16) * 100;
        const lit = pct > threshold;
        const isBlue = i >= 13;
        const flashRed = shiftFlash && isBlue && lit;
        const activeColor = flashRed ? '#ef4444' : color;

        return (
          <div
            key={i}
            className={`flex-1 h-4 rounded-full transition-all duration-100 ${flashRed ? 'animate-rev-flash' : ''}`}
            style={{
              background: lit ? activeColor : '#1a1a1e',
              boxShadow: lit ? `0 0 8px ${activeColor}99` : 'none',
            }}
          />
        );
      })}
    </div>
  );
}